import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/frontend/assets/images/about/about-poster2.jpeg';
import _imports_1 from '@/frontend/assets/images/about/about-2.png';
import _imports_2 from '@/frontend/assets/images/about/about-1.png';

const _withScopeId = n => (_pushScopeId("data-v-a232112c"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"poster\" data-v-a232112c><img class=\"img\" src=\"" + _imports_0 + "\" alt=\"\" data-v-a232112c><div class=\"cover\" data-v-a232112c><p class=\"item\" data-v-a232112c> “… весь мир стал искусством” </p><p class=\"item author\" data-v-a232112c> Илья Кабаков </p></div></div>", 1);

const _hoisted_2 = {
  class: "main"
};

const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"about holder-fluid\" data-v-a232112c><div class=\"item content\" data-v-a232112c><h3 class=\"title\" data-v-a232112c> О нас </h3><div class=\"description\" data-v-a232112c><p data-v-a232112c> L-collection – маркетплейс, объединяющий почитателей живописи, графики, фотографии, скульптуры, дизайна, декоративно-прикладного творчества. </p><p data-v-a232112c> Мы создали условия для быстрого поиска, покупки, оценки и продажи картин, скульптурных композиций и других предметов искусства. Зарегистрированные пользователи легко найдут работы представителей определенной художественной школы или конкретного автора, смогут пополнить коллекцию или выставить работу на продажу. </p></div></div><div class=\"item\" data-v-a232112c><img src=\"" + _imports_1 + "\" alt=\"\" class=\"img src\" data-v-a232112c></div><div class=\"item\" data-v-a232112c><img src=\"" + _imports_2 + "\" alt=\"\" class=\"img src\" data-v-a232112c></div></div>", 1);

const _hoisted_4 = {
  class: "services holder-fluid"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, " Наши услуги ", -1));

const _hoisted_6 = {
  class: "items"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "title"
};
const _hoisted_9 = {
  class: "description"
};
const _hoisted_10 = ["textContent"];
const _hoisted_11 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("section", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.services, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "item"
    }, [false ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "img",
      src: item.image,
      alt: ""
    }, null, 8, _hoisted_7)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_8, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.description, (text, indexDescription) => {
      return _openBlock(), _createElementBlock("p", {
        key: indexDescription,
        class: "item",
        textContent: _toDisplayString(text)
      }, null, 8, _hoisted_10);
    }), 128))]), _createElementVNode("button", {
      class: "button",
      onClick: $event => $options.openModalService(item)
    }, " Отправить запрос ", 8, _hoisted_11)]);
  }), 128))])])])], 64);
}